class Pivot3 {

    constructor( x = 0, y = 0, z = 0 ) {

        Object.defineProperty( this, 'isPivot3', { value: true } );

        if(!isNaN(x)) x = [ x ]
        if(!isNaN(y)) y = [ y ]
        if(!isNaN(z)) z = [ z ]

        this.x = x;
        this.y = y;
        this.z = z;

    }

    set( x, y, z ) {

        if ( z === undefined ) z = this.z; // sprite.scale.set(x,y)

        if(!isNaN(x)) x = [ x ]
        if(!isNaN(y)) y = [ y ]
        if(!isNaN(z)) z = [ z ]

        this.x = x;
        this.y = y;
        this.z = z;

        return this;

    }

    setScalar( scalar ) {
        
        if(!isNaN(scalar)) scalar = [ scalar ]

        this.x = scalar;
        this.y = scalar;
        this.z = scalar;

        return this;

    }

    setX( x ) {

        this.x = x;

        return this;

    }

    setY( y ) {

        this.y = y;

        return this;

    }

    setZ( z ) {

        this.z = z;

        return this;

    }

    setComponent( index, value ) {

        if(!isNaN(value)) value = [ value ]

        switch ( index ) {

            case 0: this.x = value; break;
            case 1: this.y = value; break;
            case 2: this.z = value; break;
            default: throw new Error( 'index is out of range: ' + index );

        }

        return this;

    }

    getComponent( index ) {

        switch ( index ) {

            case 0: return this.x;
            case 1: return this.y;
            case 2: return this.z;
            default: throw new Error( 'index is out of range: ' + index );

        }

    }

    clone() {

        return new this.constructor( this.x, this.y, this.z );

    }

    copy( v ) {

        this.x = v.x;
        this.y = v.y;
        this.z = v.z;

        return this;

    }

    add( v, w ) {

        if ( w !== undefined ) {

            console.warn( 'THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
            return this.addVectors( v, w );

        }

        this.x += v.x;
        this.y += v.y;
        this.z += v.z;

        return this;

    }

}

export { Pivot3 }